import React from 'react';
import AboutPage from './Page.tsx';
import PageFade from '@/common/components/PageFade.tsx';

const AboutRoute: React.FC = () => {
  return (
    <PageFade>
      <AboutPage />
    </PageFade>
  );
};

export default AboutRoute;
